export const filteredFondos = state => (
    state.fondoMutuo.fondos.sort(function(a, b){ return(Math.abs(b.rentabilidad) - Math.abs(a.rentabilidad))}).slice(0, 6)
);
export const fondoMutuoCard = state => state.fondoMutuo.fondos;
export const pending = state => state.fondoMutuo.pending;